import React, { useEffect, useState } from "react";
import Select from "react-select";

import { DatePicker } from "antd";
import moment from "moment";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { indian_states } from "../../components/Data/IndianStates";
import { countries } from "../../components/Data/Countries";
import { gbState } from "../../components/shared/GlobalState";
import { FaLock, FaEnvelope, FaArrowLeft, FaSave } from "react-icons/fa"; // Add this import for icons

const ProfileUpdate = () => {
  const [{ errorLogApi, user, bloodgroupOptions }] = useAtom(gbState);
  let navigate = useNavigate();
  const familyDetails = [];
  const [formData, setFormData] = useState({});
  const [userData, setUserData] = useState({});
  const [fmData, setFmData] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [cityOptions, setCityOptions] = useState();
  const [cityStateInput, setCityStateInput] = useState(false);
  const [churchList, setChurchList] = useState();
  const inputWidth = "230px";
  //Error Logging Service & Santize Input
  const placeHolderText = (text) => (
    <span className="text-sm text-light">{text}</span>
  );
  const style = {
    control: (base) => ({
      ...base,
      border: "1px solid lightgray",
      // This line disable the blue border
      boxShadow: "none",
    }),
  };
  useEffect(() => {
    let userToken = localStorage.getItem("token");
    const urlLink = `${process.env.REACT_APP_API_URL}/user/${user._id}`;
    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };
    axios(config)
      .then(function (response) {
        const dataRecieved = response?.data?.users;
        setUserData(dataRecieved);
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  }, []);
  useEffect(() => {
    setFormData({
      ...formData,
      ...userData,
    });
  }, [userData]);

  const handleChange = ({ currentTarget: input }) => {
    setFormData({
      ...formData,
      [input.name]: input.value,
    });
  };
  const inputElementWidthStyle = `w-full p-3 h-10 font-sans text-sm font-light border border-gray-300 rounded-md outline-none`;

  const handleFamilyUpdate = () => {
    let userToken = localStorage.getItem("token");

    if (!formData.email) {
      toast.error("Please enter email ID");
      return;
    }
    if (!formData.password) {
      toast.error("Please enter password");
      return;
    }
    if (!formData.confirm_password) {
      toast.error("Please enter confirm password");
      return;
    }
    if (formData.password !== formData.confirm_password && formData.password) {
      toast.error("Passwords do not match");
      return;
    }
    let config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/employee/update/${formData._id}`,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userToken}`,
      },
      data: { ...formData, image: selectedImage },
    };
    axios(config)
      .then(function (response) {
        //console.log(JSON.stringify(response.data));
        toast.success("Record Updated Successfully.");
        navigate("/dashboard-ca");
      })
      .catch(function (error) {
        //  toast.error(JSON.stringify(error.response.data.message));
        toast.error(JSON.stringify(error?.response?.data));
        errorLogApi(error, "FamilyUpdateChild", "/updateProfile");
        // console.log(error);
      });
  };

  return (
    <div className="flex w-full min-h-screen bg-gray-100">
      {" "}
      {/* Added background color and min-height */}
      <div className="w-full max-w-2xl p-8 mx-auto">
        {" "}
        {/* Increased padding and set max-width */}
        <div className="flex justify-end w-full mb-6">
          {" "}
          {/* Increased margin-bottom */}
          <button
            className="flex items-center px-4 py-2 mr-4 text-white transition duration-300 bg-gray-600 rounded-lg hover:bg-gray-700" // Added rounded-lg, hover effect, and flex
            onClick={() => navigate(-1)}
          >
            <FaArrowLeft className="mr-2" /> {/* Added icon */}
            Back
          </button>
          <button
            className="flex items-center px-4 py-2 text-white transition duration-300 bg-blue-600 rounded-lg hover:bg-blue-700" // Added rounded-lg, hover effect, and flex
            onClick={handleFamilyUpdate}
          >
            <FaSave className="mr-2" /> {/* Added icon */}
            Save
          </button>
        </div>
        <div className="p-8 bg-white rounded-lg shadow-lg">
          {" "}
          {/* Added white background, rounded corners, and shadow */}
          <h2 className="mb-6 text-2xl font-semibold text-gray-800">
            Update Password
          </h2>{" "}
          {/* Styled heading */}
          <form>
            <div className="mb-6">
              {" "}
              {/* Increased margin-bottom */}
              <label className="block mb-2 text-sm font-medium text-gray-700">
                Email
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <FaEnvelope className="text-gray-400" />
                </div>
                <input
                  type="text"
                  name="email"
                  autoComplete="new-password"
                  className="w-full py-2 pl-10 pr-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  value={formData?.email}
                  disabled
                />
              </div>
            </div>
            <div className="mb-6">
              <label className="block mb-2 text-sm font-medium text-gray-700">
                Password
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <FaLock className="text-gray-400" />
                </div>
                <input
                  type="password"
                  name="password"
                  autoComplete="new-password"
                  onChange={handleChange}
                  className="w-full py-2 pl-10 pr-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            </div>
            <div className="mb-6">
              <label className="block mb-2 text-sm font-medium text-gray-700">
                Confirm Password
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <FaLock className="text-gray-400" />
                </div>
                <input
                  type="password"
                  name="confirm_password"
                  autoComplete="off"
                  onChange={handleChange}
                  className="w-full py-2 pl-10 pr-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProfileUpdate;
